import addExperimentsFromQuery from '@wix/santa-main-r/lib/lib/common/addExperimentsFromQuery';
import experimentFactory from '@wix/santa-main-r/lib/lib/common/experimentFactory';
import getQueryUtils from '@wix/santa-main-r/lib/lib/common/getQueryUtils';
import type { Experiment } from 'experiment';

const queryUtil = getQueryUtils(window);

const { editorModel } = window;

if (editorModel) {
  editorModel.runningExperiments = addExperimentsFromQuery(
    editorModel.runningExperiments,
    queryUtil,
    'editor',
  );
  editorModel.languageCode =
    queryUtil.getParameterByName('lang') || editorModel.languageCode;
}

export default experimentFactory.build(window) as Experiment;
